import { ChevronRight } from 'lucide-react'
import { Fragment } from 'react'
import { Link } from 'react-router'

export interface BreadcrumbItem {
  label: string
  /** omit on the last item to render it as the current (non-clickable) page. */
  to?: string
  state?: unknown
}

/**
 * single breadcrumb source-of-truth used across the app. parent items are
 * muted links; the last item (no `to`) renders as bold ink, representing the
 * current page. chevrons separate each pair.
 */
export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <span className='inline-flex min-w-0 items-center gap-1.5 text-[13px]'>
      {items.map((item, i) => (
        <Fragment key={i}>
          {i > 0 ? (
            <ChevronRight className='hidden size-3.5 shrink-0 text-ink-muted sm:block' />
          ) : null}
          {/* phones show the current page only, two truncated crumbs read as
              nothing */}
          {item.to ? (
            <Link
              to={item.to}
              state={item.state}
              className='hidden truncate text-ink-muted transition-colors hover:text-ink sm:inline'
              title={item.label}
            >
              {item.label}
            </Link>
          ) : (
            <span className='truncate font-medium text-ink' title={item.label}>
              {item.label}
            </span>
          )}
        </Fragment>
      ))}
    </span>
  )
}
